import { useContext, useMemo, useState, type ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { HeaderActionsContext } from './header-actions-context';

/** Page-owned controls keep their context while being rendered in the shared header. */
export function HeaderActionsProvider({ children }: { children: ReactNode }) {
  const [target, setTarget] = useState<HTMLDivElement | null>(null);
  const value = useMemo(() => ({ target, setTarget }), [target]);
  return <HeaderActionsContext.Provider value={value}>{children}</HeaderActionsContext.Provider>;
}

export function HeaderActionsOutlet() {
  const context = useContext(HeaderActionsContext);
  return <div ref={context?.setTarget} className="platform-header-page-actions" />;
}

export function HeaderActions({ children }: { children: ReactNode }) {
  const context = useContext(HeaderActionsContext);
  return context?.target ? createPortal(children, context.target) : null;
}
